<template>
  <b-overlay :show="loading">
    <div class="row">
      <div class="col-12 mb-5">
        <dashboard-filters
          :value="filters"
          :onChange="onChangeFilters"
          :clear="clearFilters"
        />
      </div>
      <div class="col-7">
        <BarByState
          ref="by-state"
          :data="batchIndicators"
          :title="'Estados de lotes'"
        />
      </div>
      <div class="col-5">
        <BarByState
          ref="by-state"
          :data="auctionIndicators"
          :title="'Estados de subastas'"
        />
      </div>
      <div class="col-6">
        <Indicator
          title="Total Lotes"
          :quantity="indicators.totalBatches"
          color="primary"
          icon="FileTextIcon"
        />
      </div>
      <div class="col-6">
        <Indicator
          title="Total Subastas"
          :quantity="indicators.totalAuctions"
          color="primary"
          icon="FileTextIcon"
        />
      </div>
      <div class="col-6">
        <Indicator
          title="Total Comprobantes Emitidos"
          :quantity="indicators.totalReceipts"
          color="primary"
          icon="FileTextIcon"
        />
      </div>
      <div class="col-6">
        <Indicator
          title="Total Comprobantes Facturados"
          :quantity="indicators.totalInvoiceReceipts"
          color="primary"
          icon="FileTextIcon"
        />
      </div>
    </div>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import Indicator from '@/febos/aduanas/dashboard/views/components/Indicator';
import {
  getAuctionsIndicators,
  getBatchesIndicators,
  getReceiptsIndicators
} from '@/febos/aduanas/dashboard/store/actions';
import BarByState from '@/febos/aduanas/dashboard/views/components/BarByState';
import { receiptsCodeStates } from '@/febos/aduanas/receipts/views/utils/constants';
import DashboardFilters from '@/febos/aduanas/dashboard/views/components/DashboardFilters';

export default {
  data() {
    return {
      filters: '',
      searchParam: false,
      indicators: {
        totalBatches: 0,
        totalAuctions: 0,
        totalInvoiceReceipts: 0,
        totalReceipts: 0
      }
    };
  },
  components: {
    Indicator,
    BarByState,
    DashboardFilters
  },
  watch: {
    batchIndicators() {
      this.makeIndicators();
    },
    auctionIndicators() {
      this.makeIndicators();
    },
    receiptIndicators() {
      this.makeIndicators();
    }
  },
  computed: {
    ...mapGetters('dashboard', [
      'loading',
      'batchIndicators',
      'auctionIndicators',
      'receiptIndicators'
    ])
  },
  methods: {
    ...mapActions('dashboard', {
      getAuctionsIndicators: getAuctionsIndicators.name,
      getBatchesIndicators: getBatchesIndicators.name,
      getReceiptsIndicators: getReceiptsIndicators.name,
    }),
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        let filterNew = '';
        if (filters.includes('gestoraId')) {
          filterNew = filters.replace('gestoraId', 'lote.gestoraId');
        } else {
          filterNew = filters;
        }
        await this.fetchAuctionIndicators(filters);
        await this.fetchBatchIndicators(filters);
        await this.fetchReceiptsIndicators(filterNew);
        await this.makeIndicators();
      }
    },
    clearFilters() {
      // TODO: try to change to default filter state for current view.
      this.$router.go();
    },
    async fetchAuctionIndicators(filters) {
      const body = {
        filtros: filters,
        campos: 'estado',
        operacion: 'count',
        debug: 'si'
      };
      this.getAuctionsIndicators(body);
    },
    async fetchBatchIndicators(filters) {
      const body = {
        filtros: filters,
        campos: 'estado',
        operacion: 'count',
        debug: 'si'
      };
      this.getBatchesIndicators(body);
    },
    async fetchReceiptsIndicators(filters) {
      const body = {
        filtros: filters,
        campos: 'estado',
        operacion: 'count',
        debug: 'si'
      };
      this.getReceiptsIndicators(body);
    },
    makeIndicators() {
      const totalBatches = this.batchIndicators
        .reduce((total, item) => total + item.quantity, 0);
      const totalAuctions = this.auctionIndicators
        .reduce((total, item) => total + item.quantity, 0);
      const totalReceipts = this.receiptIndicators.reduce((total, item) => {
        if (item.status === receiptsCodeStates.emitido) {
          return total + item.quantity;
        }
        return total;
      }, 0);
      const totalInvoiceReceipts = this.receiptIndicators.reduce((total, item) => {
        if (item.status === receiptsCodeStates.facturado) {
          return total + item.quantity;
        }
        return total;
      }, 0);
      this.indicators = {
        totalBatches,
        totalAuctions,
        totalReceipts,
        totalInvoiceReceipts
      };
    }
  },
  async created() {
    await this.makeIndicators();
  }
};
</script>
